<template>
  <TableList
    v-rect-loading="loading"
    class="job-template-list"
    row-key="id"
    :title="$t(`${i18nPrefix}.title`)"
    :listData="jobTemplateList"
    :tableColumns="tableColumns"
    :pagination="pagination"
    :createBtnLabel="$t(`${i18nPrefix}.btn.add`)"
    :defaultSort="{ prop: 'status', order: 'descending'}"
    @create="handleCreateTemplate"
    @action="handleEditTemplate"
    @sort-change="handleSortChange"
    @pagination-change="handlePaginationChange"
  >
    <template #filter>
      <el-select v-model="selectedStatus" clearable class="status-filter" @change="handleSelectedStatus">
        <el-option
          v-for="status in statusOptions"
          :key="status.value"
          :value="status.value"
          :label="status.label"
        />
      </el-select>
      <el-input
        v-model="keywords"
        clearable
        class="keywords-filter"
        :placeholder="$t(`${i18nPrefix}.placeholder.keywords`)"
        @input="handleKeywordsChange"
      />
    </template>
    <template #status="{ data, row }">
      <el-switch :value="data === '1'" @change="handleStatusChange(row)"></el-switch>
    </template>
  </TableList>
</template>

<script>
import TableList from '@/components/tableList/allowDragSortTable.vue'
import _ from 'lodash'
import { addI18nProperty } from '@/i18n'
import { mapActions } from 'vuex'

export default {
  components: {
    TableList
  },
  data () {
    return {
      i18nPrefix: 'admin.company.jobTemplateManagement',
      loading: false,
      selectedStatus: null,
      keywords: null,
      jobTemplateList: [],
      order: 'status',
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.companyName`),
          dataKey: 'company.i18n_name',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.enTemplateName`),
          dataKey: 'title',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.cnTemplateName`),
          dataKey: 'cn_title',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.status`),
          dataKey: 'status',
          slotName: 'status',
          sort: {
            enable: 'custom',
            orders: ['descending', 'ascending']
          }
        }
      ]
      return columns
    },
    statusOptions () {
      return [
        {
          value: 1,
          label: this.$t(`${this.i18nPrefix}.label.enabledTemplate`)
        },
        {
          value: 2,
          label: this.$t(`${this.i18nPrefix}.label.disabledTemplate`)
        }
      ]
    }
  },
  created () {
    this.loadJobTemplateList()
  },
  methods: {
    ...mapActions('jobTemplate', ['getJobTemplateList', 'updateJobTemplate']),
    async loadJobTemplateList (reload) {
      this.loading = true
      if (reload) {
        this.pagination.page = 1
      }
      try {
        const params = {
          order: this.order,
          status: this.selectedStatus,
          keywords: this.keywords,
          page: this.pagination.page,
          page_size: this.pagination.pageSize
        }
        const resp = await this.getJobTemplateList(params)
        if (resp && resp.result) {
          this.jobTemplateList = _.map(resp.result, jobTemplate => {
            addI18nProperty(jobTemplate.company, 'i18n_name', 'cn_name', 'name')
            return jobTemplate
          })
          this.pagination.total = resp.total
        }
      } finally {
        this.loading = false
      }
    },
    handleSelectedStatus () {
      this.loadJobTemplateList(true)
    },
    handleKeywordsChange () {
      if (!this.keywordsSearchDebounce) {
        this.keywordsSearchDebounce = _.debounce(this.handleSearch, 1000)
      }
      this.keywordsSearchDebounce()
    },
    handleSearch () {
      this.loadJobTemplateList(true)
    },
    handlePaginationChange () {
      this.loadJobTemplateList()
    },
    handleCreateTemplate () {
      this.$router.push('/v-admin/job-template/management/add')
    },
    handleEditTemplate (row) {
      this.$router.push(`/v-admin/job-template/management/edit/${row.id}`)
    },
    async handleStatusChange (row) {
      this.loading = true
      try {
        const newStatus = row.status === '1' ? '2' : '1'
        const data = {
          templateId: row.id,
          data: {
            status: newStatus,
            update_status: true
          }
        }
        const resp = await this.updateJobTemplate(data)
        if (resp === 'success') {
          row.status = newStatus
          this.$message.success(this.$t('common.message.optionSuccess'))
        }
      } finally {
        this.loading = false
      }
    },
    handleSortChange (prop, order) {
      if (order) {
        this.order = prop
      } else {
        this.order = `-${prop}`
      }
      this.loadJobTemplateList(true)
    }
  }
}
</script>

<style lang="scss" scoped>
.job-template-list {
  .keywords-filter {
  }

  .enable-btn {
    margin-left: 10px;

    .enable-btn-inner {
      padding: 0;
    }
  }
}
</style>
